export interface Article {
  id: string;
  title: string;
  slug: string;
  categoryId: string;
  categoryName: string;
  categorySlug: string;
  excerpt: string;
  content: ArticleContent[];
  image: string;
  author: string;
  authorAvatar: string;
  date: string;
  readTime: number;
  tags: string[];
  featured: boolean;
  viewCount: number;
  likeCount: number;
}

export interface ArticleContent {
  type: 'paragraph' | 'heading' | 'image' | 'list' | 'quote';
  value: string;
  items?: string[];
  caption?: string;
}

export const articles: Article[] = [
  {
    id: 'article-1',
    title: '大理洱海边的10个浪漫秘境，比电影画面还美',
    slug: 'dali-erhai-romantic-spots',
    categoryId: 'cat-5',
    categoryName: '度假推荐',
    categorySlug: 'resort-recommendations',
    excerpt: '苍山洱海间藏着许多不为人知的浪漫角落。从海舌公园的日出到双廊的日落，我们为你整理了10个适合情侣打卡的绝美秘境，每一步都是风景。',
    content: [
      { type: 'paragraph', value: '大理，这座被苍山环抱、洱海滋养的古城，自古以来就是诗意与浪漫的代名词。对于情侣而言，这里不仅是旅行的目的地，更是一段值得珍藏的时光。在这篇攻略中，我们将带你探寻洱海周边10个鲜为人知的浪漫角落。' },
      { type: 'heading', value: '1. 海舌生态公园 — 看一场洱海日出' },
      { type: 'paragraph', value: '海舌公园是深入洱海的一个狭长半岛，形状如舌，故名海舌。清晨五点半，和爱人一起驱车前往，在微凉的晨风中等待第一缕阳光洒在洱海水面上。那一刻的金色光芒与远处苍山的剪影交织，是任何相机都无法完全捕捉的浪漫。' },
      { type: 'image', value: 'https://readdy.ai/api/search-image?query=Sunrise%20view%20over%20Dali%20Erhai%20Lake%20with%20Cangshan%20mountain%20silhouette%2C%20golden%20sunlight%20reflecting%20on%20calm%20water%2C%20wooden%20pier%20extending%20into%20lake%2C%20peaceful%20morning%20atmosphere%2C%20dramatic%20clouds%2C%20warm%20golden%20and%20pink%20tones&width=1200&height=600&seq=article-1-img-1&orientation=landscape', caption: '海舌公园日出，洱海最美的时刻' },
      { type: 'heading', value: '2. 双廊古镇 — 日落时分的海景露台' },
      { type: 'paragraph', value: '双廊是洱海边最负盛名的古镇之一，许多临海的民宿都拥有绝美的日落观景台。推荐选择一家有露台的客栈，傍晚时分，两人依偎着看太阳缓缓沉入苍山背后，天空从橙红渐变为深紫，整个世界仿佛只属于你们。' },
      { type: 'quote', value: '在大理的每一天，我们都在感叹：原来浪漫可以如此简单。一杯咖啡，一缕阳光，一个相视而笑。' },
      { type: 'heading', value: '3. 喜洲古镇 — 白族民居里的慢时光' },
      { type: 'paragraph', value: '相比双廊的繁华，喜洲更多了一份古朴与宁静。穿梭在保存完好的白族民居之间，三坊一照壁、四合五天井的建筑格局让人仿佛穿越了时光。转角处的喜洲粑粑和手工酸奶，是情侣间最甜蜜的分享。' },
      { type: 'heading', value: '4. 周城扎染 — 一起创造独一无二的纪念品' },
      { type: 'paragraph', value: '在周城，你们可以亲手体验白族扎染工艺。从设计图案到染色晾晒，两人合力完成一条独一无二的扎染方巾。这不仅是一件旅行纪念品，更是共同创造的美好回忆。' },
      { type: 'heading', value: '5. 挖色码头 — 最出片的爱情打卡地' },
      { type: 'paragraph', value: '挖色码头是近年来在小红书上爆火的拍照胜地。延伸入湖的栈道和散落在水中的枯树构成了极具艺术感的画面。建议在下午三四点前往，光线最为柔和，随手一拍都是大片。' },
      { type: 'image', value: 'https://readdy.ai/api/search-image?query=Romantic%20couple%20standing%20on%20wooden%20pier%20over%20Erhai%20Lake%20in%20Dali%20at%20sunset%2C%20beautiful%20golden%20hour%20light%2C%20mountain%20background%2C%20reflection%20in%20water%2C%20dreamy%20atmosphere%2C%20cinematic%20composition&width=1200&height=600&seq=article-1-img-2&orientation=landscape', caption: '挖色码头，洱海边的爱情定格' },
      { type: 'heading', value: '6. 小普陀 — 湖心小岛的宁静' },
      { type: 'paragraph', value: '小普陀是洱海中的一座袖珍小岛，乘船上岛不过十分钟。岛上的观音阁香火缭绕，许多情侣会在这里许下心愿。站在岛上回望洱海，碧波万顷，心旷神怡。' },
      { type: 'heading', value: '7-10. 更多隐秘浪漫角落' },
      { type: 'list', items: ['蝴蝶泉 — 每年农历四月十五蝴蝶会，漫天彩蝶飞舞', '才村码头 — 骑行洱海的最佳起点，沿途风光无限', '龙龛码头 — 比挖色更小众的拍照点，游客稀少', '鹿卧山 — 俯瞰整个洱海的制高点，适合看全景'] },
      { type: 'paragraph', value: '大理的浪漫，藏在每一条小巷、每一片云彩、每一缕阳光里。不需要刻意寻找，放慢脚步，牵着爱人的手，你们走过的每一步都是风景。' },
    ],
    image: 'https://readdy.ai/api/search-image?query=Aerial%20view%20of%20Dali%20Erhai%20Lake%20with%20Cangshan%20mountains%2C%20traditional%20white%20buildings%20by%20the%20lake%2C%20golden%20sunset%20light%2C%20dramatic%20clouds%2C%20peaceful%20romantic%20landscape%2C%20Yunnan%20China%20travel%20destination&width=1200&height=600&seq=article-1-hero&orientation=landscape',
    author: '小雨',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20young%20asian%20woman%20with%20warm%20smile%2C%20soft%20natural%20lighting%2C%20elegant%20casual%20style%2C%20cream%20background%2C%20friendly%20approachable%20look&width=100&height=100&seq=author-xiaoyu&orientation=squarish',
    date: '2026-07-28',
    readTime: 12,
    tags: ['大理', '洱海', '情侣旅行', '云南', '浪漫打卡', '度假'],
    featured: true,
    viewCount: 32680,
    likeCount: 2841,
  },
  {
    id: 'article-2',
    title: '魔都约会指南：上海最浪漫的15个小众约会地',
    slug: 'shanghai-romantic-date-spots',
    categoryId: 'cat-1',
    categoryName: '约会攻略',
    categorySlug: 'date-guide',
    excerpt: '外滩人太多？新天地逛腻了？这份上海小众约会地图为你解锁藏在弄堂里、屋顶上、江畔边的浪漫角落，让你的每一次约会都独一无二。',
    content: [
      { type: 'paragraph', value: '上海，这座永远不会让你无聊的城市，藏着太多适合约会的小角落。告别千篇一律的电影院和连锁餐厅，我们花了三个月时间，走遍浦西浦东，为你精选了15个真正值得去的约会地点。' },
      { type: 'heading', value: '1. 建投书局·浦江店 — 可以看江景的书店约会' },
      { type: 'paragraph', value: '位于北外滩的建投书局，拥有长达32米的落地玻璃窗，正对黄浦江。点两杯咖啡，各自挑一本喜欢的书，在窗边的高脚椅上并肩而坐，江面上来往的船只和远处的陆家嘴天际线就是最美的背景。这里安静、有格调，是文艺情侣的理想去处。' },
      { type: 'image', value: 'https://readdy.ai/api/search-image?query=Modern%20bookstore%20with%20floor%20to%20ceiling%20windows%20overlooking%20Shanghai%20Huangpu%20River%20and%20Lujiazui%20skyline%2C%20reading%20area%20with%20warm%20wooden%20tables%2C%20coffee%20corner%2C%20quiet%20romantic%20atmosphere%2C%20sunset%20golden%20light&width=1200&height=600&seq=article-2-img-1&orientation=landscape', caption: '建投书局，黄浦江边的文艺约会地' },
      { type: 'heading', value: '2. 哥伦比亚公园 — 摩洛哥风情的泳池约会' },
      { type: 'paragraph', value: '上生新所里的哥伦比亚公园，保留了近百年前的英制露天泳池。如今泳池四周开满了精致的餐厅和咖啡馆。坐在泳池边喝个下午茶，蓝白相间的马赛克瓷砖和拱形廊柱，恍惚间以为到了摩洛哥。' },
      { type: 'quote', value: '在上海约会的最高境界：明明在市区，却感觉像在度假。' },
      { type: 'heading', value: '3. 沙美大楼天台 — 俯瞰外滩的屋顶秘境' },
      { type: 'paragraph', value: '沙美大楼是外滩源一栋低调的历史建筑，顶楼的天台酒吧可以360度俯瞰外滩全景。傍晚时分，看着万国建筑群逐一亮起灯光，手中举着鸡尾酒，耳边是爵士乐，这是属于上海的独有浪漫。' },
      { type: 'heading', value: '4-15. 更多约会好去处' },
      { type: 'list', items: ['徐汇滨江 — 傍晚沿着黄浦江骑行，晚风是最温柔的陪伴', '多伦路文化名人街 — 在百年老街上慢慢走，每一步都是故事', '1933老场坊 — 独特的建筑光影，随手拍都是大片', '共青森林公园 — 城市里的森林秘境，适合野餐和发呆', 'M50创意园 — 一起逛画廊，讨论哪幅画最好看', '永嘉路 — 梧桐树下的咖啡馆一条街，每个转角都有惊喜'] },
    ],
    image: 'https://readdy.ai/api/search-image?query=Romantic%20Shanghai%20cityscape%20at%20blue%20hour%20with%20Lujiazui%20skyline%20lights%20reflecting%20on%20Huangpu%20River%2C%20couples%20walking%20along%20the%20Bund%2C%20elegant%20modern%20city%20vibe%2C%20warm%20golden%20streetlights%2C%20romantic%20atmosphere&width=1200&height=600&seq=article-2-hero&orientation=landscape',
    author: '思涵',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20young%20asian%20woman%20with%20elegant%20style%2C%20warm%20smile%2C%20soft%20studio%20lighting%2C%20cream%20background%2C%20friendly%20professional%20look&width=100&height=100&seq=author-sihan&orientation=squarish',
    date: '2026-07-25',
    readTime: 15,
    tags: ['上海', '约会', '城市攻略', '餐厅推荐', '浪漫打卡'],
    featured: true,
    viewCount: 45210,
    likeCount: 3672,
  },
  {
    id: 'article-3',
    title: '巴厘岛蜜月全攻略：从落地到离开的完美行程',
    slug: 'bali-honeymoon-complete-guide',
    categoryId: 'cat-2',
    categoryName: '蜜月旅行',
    categorySlug: 'honeymoon',
    excerpt: '计划去巴厘岛度蜜月？这篇万字长文覆盖了签证、航班、酒店、景点、美食和拍照攻略，手把手教你规划一场完美的巴厘岛蜜月之旅。',
    content: [
      { type: 'paragraph', value: '巴厘岛，这座被称为"众神之岛"的热带天堂，是全球情侣蜜月旅行的首选目的地之一。丰富的自然景观、深厚的文化底蕴、一流的度假酒店，让巴厘岛成为了蜜月旅行的完美画布。' },
      { type: 'heading', value: '行前准备' },
      { type: 'paragraph', value: '中国公民前往巴厘岛可以享受落地签政策（VOA），费用约35美元。建议提前准备好返程机票、酒店预订单和充足的现金。巴厘岛使用印尼盾（IDR），1元人民币约等于2100印尼盾。' },
      { type: 'heading', value: '蜜月酒店推荐' },
      { type: 'image', value: 'https://readdy.ai/api/search-image?query=Luxury%20private%20pool%20villa%20in%20Bali%20resort%20with%20tropical%20garden%2C%20flower%20petals%20decoration%20on%20bed%2C%20open%20air%20bathroom%2C%20swaying%20palm%20trees%2C%20warm%20sunset%20light%2C%20romantic%20honeymoon%20setting&width=1200&height=600&seq=article-3-img-1&orientation=landscape', caption: '巴厘岛私人泳池别墅，蜜月的完美之选' },
      { type: 'list', items: ['乌布 — 推荐Hanging Gardens，双层无边泳池享誉全球', '水明漾 — 推荐W Bali，时尚设计加一线海景', '乌鲁瓦图 — 推荐Bvlgari Resort，悬崖之上的终极浪漫', '努沙杜瓦 — 推荐St Regis，私密海滩配顶级管家服务'] },
      { type: 'heading', value: '7天蜜月行程推荐' },
      { type: 'paragraph', value: 'Day 1-2：乌布 — 稻田漫步、圣猴森林、德格拉朗梯田秋千\nDay 3-4：水明漾 — 海滩俱乐部、日落鸡尾酒、精致晚餐\nDay 5-6：乌鲁瓦图 — 悬崖寺庙、冲浪体验、海鲜烧烤\nDay 7：努沙杜瓦 — SPA放松、水上运动、返程' },
      { type: 'quote', value: '巴厘岛教会我们：蜜月不是赶路，而是用心感受每一个当下的美好。' },
    ],
    image: 'https://readdy.ai/api/search-image?query=Bali%20tropical%20paradise%20aerial%20view%20with%20rice%20terraces%20and%20temples%2C%20lush%20green%20jungle%2C%20traditional%20Balinese%20architecture%2C%20golden%20sunset%20sky%2C%20exotic%20romantic%20honeymoon%20destination&width=1200&height=600&seq=article-3-hero&orientation=landscape',
    author: '晓雯',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20young%20asian%20woman%20with%20bright%20smile%2C%20travel%20style%20outfit%2C%20soft%20natural%20lighting%2C%20cream%20background%2C%20friendly%20energetic%20look&width=100&height=100&seq=author-xiaowen&orientation=squarish',
    date: '2026-07-20',
    readTime: 20,
    tags: ['巴厘岛', '蜜月', '海岛旅行', '豪华酒店', '印尼'],
    featured: true,
    viewCount: 56780,
    likeCount: 4893,
  },
  {
    id: 'article-4',
    title: '杭州西湖边的10间绝美民宿，住进江南的诗意里',
    slug: 'hangzhou-westlake-boutique-hotels',
    categoryId: 'cat-3',
    categoryName: '浪漫套餐',
    categorySlug: 'romantic-packages',
    excerpt: '西湖边的精品民宿，每一间都是一首写给江南的情诗。从龙井茶园到满觉陇，我们精选了10间最适合情侣入住的浪漫民宿。',
    content: [
      { type: 'paragraph', value: '杭州的魅力，在于你永远可以在西湖边找到一个安静的角落。而对于情侣来说，选对一间民宿，就选对了一半的旅行体验。以下是我们实地探访后精选的10间西湖周边最美民宿。' },
      { type: 'heading', value: '1. 法云安缦 — 隐于灵隐寺旁的诗意栖居' },
      { type: 'paragraph', value: '法云安缦坐落在灵隐寺旁的法云古村中，由一片明清时期的古村落改建而成。青石板路、竹林掩映、晨钟暮鼓，这里的一切都让人忘记城市的喧嚣。' },
      { type: 'image', value: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20boutique%20hotel%20in%20Hangzhou%20near%20West%20Lake%2C%20ancient%20architecture%20with%20bamboo%20garden%2C%20tea%20ceremony%20setting%2C%20warm%20soft%20lighting%2C%20zen%20peaceful%20atmosphere%2C%20Jiangnan%20style%20interior&width=1200&height=600&seq=article-4-img-1&orientation=landscape', caption: '法云安缦，竹林深处的隐世居所' },
      { type: 'heading', value: '2. 西溪悦榕庄 — 水上江南的极致浪漫' },
      { type: 'paragraph', value: '悦榕庄坐落于西溪湿地内，每间客房都是独栋水景别墅。私人码头、室内温泉、星空露台，在这里度过的每一分钟都像是从画卷中偷来的时光。' },
      { type: 'list', items: ['龙井草堂 — 茶园环绕，清晨被鸟鸣和茶香唤醒', '满觉陇·山舍 — 秋季桂花飘香，推窗即景', '白乐桥·花迹 — 白乐桥边的设计师民宿，极简美学', '夕霞小筑 — 可俯瞰西湖全景的屋顶露台'] },
    ],
    image: 'https://readdy.ai/api/search-image?query=Aerial%20view%20of%20Hangzhou%20West%20Lake%20with%20traditional%20Chinese%20pavilions%20and%20willow%20trees%2C%20misty%20morning%20atmosphere%2C%20Leifeng%20Pagoda%20in%20distance%2C%20romantic%20Jiangnan%20landscape%2C%20soft%20dreamy%20light&width=1200&height=600&seq=article-4-hero&orientation=landscape',
    author: '建豪',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20young%20asian%20man%20with%20gentle%20smile%2C%20casual%20stylish%20look%2C%20soft%20studio%20lighting%2C%20cream%20background%2C%20friendly%20approachable&width=100&height=100&seq=author-jianhao&orientation=squarish',
    date: '2026-07-18',
    readTime: 10,
    tags: ['杭州', '西湖', '民宿', '江南', '情侣住宿', '精品酒店'],
    featured: false,
    viewCount: 28940,
    likeCount: 2156,
  },
  {
    id: 'article-5',
    title: '京都红叶季约会路线：在千年古都谈一场秋天的恋爱',
    slug: 'kyoto-autumn-date-routes',
    categoryId: 'cat-4',
    categoryName: '打卡景点',
    categorySlug: 'photo-spots',
    excerpt: '京都的秋天，是一首写给恋人的散文诗。红叶、寺庙、和服、抹茶，跟着这条精心设计的路线，在千年古都拍下最美的情侣照。',
    content: [
      { type: 'paragraph', value: '如果说春天的京都是粉色樱花的天下，那么秋天的京都，就是一幅浓墨重彩的红叶画卷。每年的11月中旬到12月初，整个京都都被染上了深深浅浅的红，这是最适合情侣漫步的季节。' },
      { type: 'heading', value: '和服体验 + 清水寺' },
      { type: 'paragraph', value: '约会的第一个环节，建议从和服体验开始。在清水寺附近的冈本和服店换上精美的和服，两人身着传统服饰并肩走在二年坂、三年坂的石板路上，每一帧都像是电影画面。' },
      { type: 'image', value: 'https://readdy.ai/api/search-image?query=Kyoto%20Japan%20autumn%20foliage%20at%20Kiyomizu%20temple%20with%20traditional%20wooden%20architecture%2C%20couple%20in%20kimono%20walking%20on%20stone%20path%2C%20vibrant%20red%20and%20orange%20maple%20leaves%2C%20warm%20afternoon%20sunlight%2C%20romantic%20atmosphere&width=1200&height=600&seq=article-5-img-1&orientation=landscape', caption: '清水寺红叶与和服，京都最美的秋日记忆' },
      { type: 'heading', value: '岚山竹林 + 嵯峨野小火车' },
      { type: 'paragraph', value: '乘坐复古的嵯峨野观光小火车穿越岚山峡谷，窗外的红叶从眼前掠过。下了火车，漫步在岚山竹林中，阳光透过竹叶洒下斑驳光影，牵着爱人的手，安静地走一段路，就已足够美好。' },
      { type: 'quote', value: '在京都，我们明白了一件事：最好的约会，不是去了多远的地方，而是身边的这个人，让你觉得整个世界都变温柔了。' },
      { type: 'list', items: ['永观堂 — 京都红叶第一名所，夜枫尤其惊艳', '东福寺 — 通天桥上的红叶隧道', '贵船神社 — 山间灯笼参道，红叶加雪景更绝', '南禅寺 — 水路阁的红砖与红叶，西洋与和风的碰撞'] },
    ],
    image: 'https://readdy.ai/api/search-image?query=Kyoto%20Japan%20arashiyama%20bamboo%20grove%20with%20autumn%20colors%2C%20sunlight%20streaming%20through%20bamboo%2C%20traditional%20Japanese%20aesthetic%2C%20peaceful%20romantic%20path%2C%20warm%20golden%20and%20green%20tones&width=1200&height=600&seq=article-5-hero&orientation=landscape',
    author: '小雨',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20young%20asian%20woman%20with%20warm%20smile%2C%20soft%20natural%20lighting%2C%20elegant%20casual%20style%2C%20cream%20background&width=100&height=100&seq=author-xiaoyu-2&orientation=squarish',
    date: '2026-07-15',
    readTime: 14,
    tags: ['京都', '日本', '红叶', '和服', '情侣拍照', '秋天'],
    featured: false,
    viewCount: 38920,
    likeCount: 3204,
  },
  {
    id: 'article-6',
    title: '情侣必吃的10家上海氛围感餐厅，约会从不踩雷',
    slug: 'shanghai-romantic-restaurants',
    categoryId: 'cat-6',
    categoryName: '美食探店',
    categorySlug: 'food-discovery',
    excerpt: '从外滩的米其林到弄堂里的私房菜，这10家餐厅不仅是味蕾的享受，更是约会氛围的保证。人均从200到2000，总有一家适合你们的预算。',
    content: [
      { type: 'paragraph', value: '选对餐厅，约会就成功了一半。在上海这座美食之都，我们精挑细选了10家既有氛围又有实力的约会餐厅，涵盖不同菜系和价位，让你从此告别"吃什么"的纠结。' },
      { type: 'heading', value: '高端之选（人均1000+）' },
      { type: 'list', items: ['Ultraviolet by Paul Pairet — 全球首家感官餐厅，每晚仅10席', 'Jean Georges — 外滩三号的法式浪漫，窗边座位需提前一个月', '8½ Otto e Mezzo Bombana — 意大利境外唯一的米其林三星意大利餐厅'] },
      { type: 'heading', value: '中端精选（人均300-800）' },
      { type: 'list', items: ['Mercato — 外滩六号，黑松露披萨配黄浦江夜景', 'The Nest — 外滩源，生蚝与鸡尾酒的天作之合', 'Le Verre à Vin — 长乐路上最地道的法式小酒馆', '蝶舍 — 胶州路独栋洋房里的新中式料理'] },
      { type: 'heading', value: '亲民之选（人均100-300）' },
      { type: 'list', items: ['RAC Bar — 安福路上的法式可丽饼，周末brunch首选', 'Alimentari — 意式熟食店风格的轻松约会', 'Green & Safe — 有机农场概念，健康又美味'] },
      { type: 'quote', value: '美食是爱情最好的催化剂。一顿用心的晚餐，胜过千言万语。' },
      { type: 'image', value: 'https://readdy.ai/api/search-image?query=Elegant%20fine%20dining%20restaurant%20with%20candlelit%20table%20overlooking%20city%20night%20skyline%2C%20romantic%20dim%20lighting%2C%20gourmet%20plated%20dishes%2C%20wine%20glasses%2C%20luxurious%20interior%2C%20warm%20ambient%20atmosphere&width=1200&height=600&seq=article-6-img-1&orientation=landscape', caption: '在上海，每一顿精心准备的晚餐都是一场约会' },
    ],
    image: 'https://readdy.ai/api/search-image?query=Romantic%20Shanghai%20restaurant%20interior%20with%20dim%20candlelight%2C%20elegant%20table%20setting%20with%20flowers%2C%20city%20night%20view%20through%20large%20windows%2C%20intimate%20atmosphere%2C%20warm%20golden%20lighting%2C%20luxury%20dining&width=1200&height=600&seq=article-6-hero&orientation=landscape',
    author: '思涵',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20young%20asian%20woman%20with%20elegant%20style%2C%20warm%20smile%2C%20soft%20studio%20lighting%2C%20cream%20background&width=100&height=100&seq=author-sihan-2&orientation=squarish',
    date: '2026-07-12',
    readTime: 11,
    tags: ['上海', '餐厅推荐', '情侣晚餐', '美食', '约会'],
    featured: false,
    viewCount: 52100,
    likeCount: 4356,
  },
  {
    id: 'article-7',
    title: '三亚海棠湾 vs 亚龙湾：情侣度假选哪个更浪漫？',
    slug: 'sanya-beach-resort-comparison',
    categoryId: 'cat-5',
    categoryName: '度假推荐',
    categorySlug: 'resort-recommendations',
    excerpt: '三亚海棠湾和亚龙湾各有千秋，一个奢华私密一个成熟便利。我们从酒店、沙滩、餐饮、娱乐四个维度帮你做出最适合情侣的选择。',
    content: [
      { type: 'paragraph', value: '三亚作为国内最热门的海岛度假目的地，海棠湾和亚龙湾是两个最受情侣青睐的湾区。但两者的风格差异明显，选错了可能会影响整个度假体验。这篇文章帮你一次搞清楚。' },
      { type: 'heading', value: '海棠湾：奢华私密派' },
      { type: 'paragraph', value: '海棠湾是三亚的新兴湾区，拥有绵长的海岸线和一线奢华酒店集群。这里的沙滩更宽阔安静，适合追求私密和品质的情侣。艾迪逊、瑰丽、亚特兰蒂斯等顶级酒店都在这里。' },
      { type: 'image', value: 'https://readdy.ai/api/search-image?query=Luxury%20resort%20infinity%20pool%20overlooking%20tropical%20ocean%20in%20Sanya%20Haitang%20Bay%2C%20private%20cabana%20with%20white%20curtains%2C%20couple%20lounging%2C%20turquoise%20water%2C%20palm%20trees%2C%20blue%20sky%2C%20paradise%20atmosphere&width=1200&height=600&seq=article-7-img-1&orientation=landscape', caption: '海棠湾，三亚的奢华新地标' },
      { type: 'heading', value: '亚龙湾：成熟便利派' },
      { type: 'paragraph', value: '亚龙湾是三亚最老牌的度假区，配套设施成熟，餐饮选择丰富。沙滩质量被誉为"天下第一湾"，沙质细腻洁白。丽思卡尔顿、瑞吉、万豪等酒店选择多样。' },
      { type: 'heading', value: '终极建议' },
      { type: 'paragraph', value: '如果这是你们的第一次三亚之旅，希望体验丰富、逛街吃饭方便，选亚龙湾。如果你们追求极致的私密和奢华，想要一个不被打扰的二人世界，选海棠湾。预算充足的话，两个湾区各住两晚也是不错的选择。' },
    ],
    image: 'https://readdy.ai/api/search-image?query=Aerial%20view%20of%20Sanya%20tropical%20beach%20resort%20with%20crystal%20clear%20turquoise%20water%2C%20white%20sand%20beach%2C%20luxury%20hotels%20along%20coastline%2C%20green%20tropical%20vegetation%2C%20sunny%20day%2C%20paradise%20island%20vibe&width=1200&height=600&seq=article-7-hero&orientation=landscape',
    author: '明哲',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20young%20asian%20man%20with%20friendly%20smile%2C%20casual%20travel%20style%2C%20soft%20natural%20lighting%2C%20cream%20background&width=100&height=100&seq=author-mingzhe&orientation=squarish',
    date: '2026-07-10',
    readTime: 13,
    tags: ['三亚', '海棠湾', '亚龙湾', '海岛度假', '情侣旅行', '酒店推荐'],
    featured: false,
    viewCount: 43500,
    likeCount: 3678,
  },
  {
    id: 'article-8',
    title: '周年纪念日怎么过？12种创意庆祝方式让你的TA感动落泪',
    slug: 'anniversary-creative-ideas',
    categoryId: 'cat-1',
    categoryName: '约会攻略',
    categorySlug: 'date-guide',
    excerpt: '告别千篇一律的晚餐+电影，这12种周年纪念日创意庆祝方式从DIY手工到星空露营，总有一种能让你的TA感动到流泪。',
    content: [
      { type: 'paragraph', value: '每年的纪念日都吃饭看电影？是时候升级你的浪漫技能了！我们从上百对情侣的真实经验中，精选了12种创意庆祝方式，保证让你的另一半眼前一亮、心头一暖。' },
      { type: 'heading', value: '经典升级版' },
      { type: 'list', items: ['手写365张小纸条，装进玻璃罐里，每一张都是一句情话', '重走第一次约会路线，在每个地点拍一张同样的照片', '定制一本属于你们的照片书，记录一年来的点点滴滴'] },
      { type: 'heading', value: '体验式庆祝' },
      { type: 'list', items: ['预定一次双人SPA，在芳香和轻柔的音乐中彻底放松', '一起去陶艺工作室，为彼此制作专属的杯子', '包场一次私人影院，放映你们最喜欢的爱情电影'] },
      { type: 'heading', value: '冒险式庆祝' },
      { type: 'list', items: ['热气球日出之旅，在千米高空说出"我爱你"', '星空露营，躺在帐篷里数流星', '双人跳伞，一起挑战极限，创造终生难忘的回忆'] },
      { type: 'quote', value: '最好的纪念日礼物，不是多贵的东西，而是你用心创造的、只属于两个人的独家记忆。' },
      { type: 'image', value: 'https://readdy.ai/api/search-image?query=Romantic%20surprise%20celebration%20with%20candles%20and%20rose%20petals%20arranged%20in%20heart%20shape%2C%20warm%20cozy%20room%20decorated%20with%20fairy%20lights%2C%20gift%20boxes%2C%20intimate%20atmosphere%2C%20soft%20golden%20lighting&width=1200&height=600&seq=article-8-img-1&orientation=landscape', caption: '用心准备的惊喜，胜过最昂贵的礼物' },
    ],
    image: 'https://readdy.ai/api/search-image?query=Romantic%20anniversary%20celebration%20setup%20with%20candles%20and%20flowers%2C%20couple%20embracing%20in%20warm%20golden%20light%2C%20elegant%20decor%2C%20intimate%20moment%2C%20soft%20romantic%20atmosphere&width=1200&height=600&seq=article-8-hero&orientation=landscape',
    author: '晓雯',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20young%20asian%20woman%20with%20bright%20smile%2C%20travel%20style%20outfit%2C%20soft%20natural%20lighting%2C%20cream%20background&width=100&height=100&seq=author-xiaowen-2&orientation=squarish',
    date: '2026-07-08',
    readTime: 9,
    tags: ['周年纪念', '约会创意', '情侣', '庆祝方式', '浪漫'],
    featured: false,
    viewCount: 67800,
    likeCount: 5643,
  },
  {
    id: 'article-9',
    title: '清迈小城慢生活：最适合情侣放空的文艺之旅',
    slug: 'chiangmai-slow-travel-couples',
    categoryId: 'cat-2',
    categoryName: '蜜月旅行',
    categorySlug: 'honeymoon',
    excerpt: '如果说曼谷是热情的，那清迈就是温柔的。这座泰北小城以它的慢节奏、低物价和满城的咖啡馆，成为了亚洲情侣最爱的文艺旅行目的地。',
    content: [
      { type: 'paragraph', value: '清迈的魅力在于它的"刚刚好"。刚刚好的温度，刚刚好的物价，刚刚好的文艺气息，一切都那么舒适自然。这里没有曼谷的喧嚣，没有普吉的商业化，只有一座愿意让你慢下来的小城。' },
      { type: 'heading', value: '古城漫游' },
      { type: 'paragraph', value: '清迈古城是一座被护城河环绕的方形区域，租一辆小摩托，载着爱人在古城的小巷中穿行。每走几步就有一座金碧辉煌的寺庙，累了就随便走进一家咖啡馆，点两杯泰式奶茶，消磨一个下午。' },
      { type: 'image', value: 'https://readdy.ai/api/search-image?query=Chiang%20Mai%20old%20city%20temple%20with%20golden%20stupa%20and%20tropical%20flowers%2C%20couple%20riding%20scooter%20on%20quiet%20street%2C%20lush%20green%20trees%2C%20warm%20afternoon%20sunlight%2C%20peaceful%20romantic%20vibe&width=1200&height=600&seq=article-9-img-1&orientation=landscape', caption: '清迈古城，每一步都是慢下来的理由' },
      { type: 'heading', value: '宁曼路文艺之旅' },
      { type: 'paragraph', value: '宁曼路是清迈的文艺心脏，聚集了上百家设计感十足的小店。从手工冰淇淋到手作皮具，从独立书店到艺术画廊，和爱人一起慢慢逛、慢慢淘，每一件小物都承载着旅途的回忆。' },
      { type: 'heading', value: '素贴山日落' },
      { type: 'paragraph', value: '傍晚驱车上素贴山，在双龙寺的金色佛塔旁俯瞰整个清迈城。夕阳将天空染成温柔的橘粉色，城市在脚下渐渐亮起灯火。这是清迈给情侣们最浪漫的礼物。' },
      { type: 'quote', value: '在清迈我们学会了一件事：最奢侈的旅行，不是住多贵的酒店，而是有大把的时间可以浪费在美好的事物上。' },
    ],
    image: 'https://readdy.ai/api/search-image?query=Chiang%20Mai%20Thailand%20aerial%20view%20with%20ancient%20temples%20and%20lush%20mountains%2C%20golden%20sunset%20light%2C%20traditional%20Lanna%20architecture%2C%20peaceful%20romantic%20cityscape%2C%20tropical%20paradise&width=1200&height=600&seq=article-9-hero&orientation=landscape',
    author: '小雨',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20young%20asian%20woman%20with%20warm%20smile%2C%20soft%20natural%20lighting%2C%20elegant%20casual%20style%2C%20cream%20background&width=100&height=100&seq=author-xiaoyu-3&orientation=squarish',
    date: '2026-07-05',
    readTime: 11,
    tags: ['清迈', '泰国', '文艺旅行', '情侣', '慢生活'],
    featured: false,
    viewCount: 31200,
    likeCount: 2540,
  },
  {
    id: 'article-10',
    title: '情侣拍照姿势大全：从剪刀手到电影感大片的进阶指南',
    slug: 'couple-photography-poses-guide',
    categoryId: 'cat-4',
    categoryName: '打卡景点',
    categorySlug: 'photo-spots',
    excerpt: '告别尴尬的剪刀手！这篇情侣拍照指南涵盖12个场景的拍照姿势，从自然抓拍到创意构图，让你和TA的每张合照都像电影海报。',
    content: [
      { type: 'paragraph', value: '拍照是情侣旅行中最重要的仪式感之一。但你是不是也经常面对镜头时手足无措，最后只能祭出万年不变的剪刀手？别担心，这篇指南将彻底改变你的情侣合照水平。' },
      { type: 'heading', value: '基础篇：自然抓拍' },
      { type: 'list', items: ['边走边聊 — 让朋友从侧面抓拍，画面自然不做作', '对视而笑 — 说一句悄悄话让对方笑出来，捕捉最真实的笑容', '背影杀 — 两人并肩看风景，画面充满故事感'] },
      { type: 'heading', value: '进阶篇：电影感构图' },
      { type: 'list', items: ['逆光剪影 — 日落时分的黄金时刻，拍出唯美轮廓', '框架构图 — 利用门窗、拱廊做天然画框', '低角度仰拍 — 以天空为背景，画面干净大气'] },
      { type: 'image', value: 'https://readdy.ai/api/search-image?query=Couple%20photography%20in%20golden%20hour%20sunset%20light%2C%20romantic%20natural%20pose%2C%20couple%20laughing%20and%20looking%20at%20each%20other%2C%20dreamy%20bokeh%20background%2C%20cinematic%20composition%2C%20warm%20golden%20tones&width=1200&height=600&seq=article-10-img-1&orientation=landscape', caption: '黄金时刻的逆光拍摄，自带浪漫滤镜' },
      { type: 'quote', value: '最好的情侣照，不是摆出最完美的姿势，而是定格下最真实的爱意。' },
    ],
    image: 'https://readdy.ai/api/search-image?query=Couple%20travel%20photography%20in%20beautiful%20natural%20landscape%2C%20romantic%20poses%2C%20golden%20hour%20sunlight%2C%20cinematic%20style%2C%20warm%20and%20dreamy%20atmosphere%2C%20professional%20composition&width=1200&height=600&seq=article-10-hero&orientation=landscape',
    author: '阿杰',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20young%20asian%20man%20with%20creative%20style%2C%20friendly%20smile%2C%20soft%20studio%20lighting%2C%20cream%20background&width=100&height=100&seq=author-ajie&orientation=squarish',
    date: '2026-07-02',
    readTime: 8,
    tags: ['拍照技巧', '情侣合照', '摄影', '旅行拍照', '打卡'],
    featured: false,
    viewCount: 72400,
    likeCount: 6120,
  },
];

export function getArticleById(id: string): Article | undefined {
  return articles.find((a) => a.id === id);
}

export function getArticlesByCategory(categoryId: string): Article[] {
  return articles.filter((a) => a.categoryId === categoryId);
}

export function getFeaturedArticles(): Article[] {
  return articles.filter((a) => a.featured);
}

export function getRelatedArticles(article: Article, limit: number = 3): Article[] {
  return articles
    .filter((a) => a.id !== article.id && (a.categoryId === article.categoryId || a.tags.some((t) => article.tags.includes(t))))
    .slice(0, limit);
}